module.exports = __webpack_public_path__ + "img/incident-report.3ecdf276.svg";